import React, { useEffect, useState } from "react";
import { Button, Table, Card, message, Spin, Space } from "antd";
import { EditOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getCandidatesApi } from "../../../apiservice/ats";


const CandidatesList = () => {
  const navigate = useNavigate();

  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCandidates = async () => {
    try {
      setLoading(true);
      const res = await getCandidatesApi();
      const list = res?.data || [];

      const formatted = list.map((c) => ({
        key: c.id,
        id: c.id,
        name: c.name,
        email: c.email,
        job: c.job_title || c.job || "—",
        status: c.status || "—",
      }));

      setCandidates(formatted);
      setLoading(false);
    } catch (err) {
      message.error("Failed to load candidates");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCandidates();
  }, []);

  const handleAddNew = () => {
    navigate("/ats/candidates/new");
  };

  const handleView = (id) => {
    navigate(`/ats/candidates/${id}`);
  };

  const handleEdit = (id) => {
    navigate(`/ats/candidates/${id}/edit`);
  };

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Applied For", dataIndex: "job", key: "job" },
    { title: "Status", dataIndex: "status", key: "status" },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => ( 
        <Space>
          <Button icon={<EyeOutlined />} onClick={() => handleView(record.id)}>View</Button>
          <Button icon={<EditOutlined />} onClick={() => handleEdit(record.id)}>Edit</Button>
        </Space>
      ),
    },
  ];

  return (
    <Card
      title="Candidates"
      extra={
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNew}>
          Add New
        </Button>
      }
      styles={{ header: { flexWrap: "wrap", height: "auto", rowGap: 8 } }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={candidates}
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 10 }}
        />
      )}
    </Card>
  );
};

export default CandidatesList;
